/**
 * Landing page board photo helpers.
 */

import { apiFetchUrl } from '@constants/apiConfig';

export const DEFAULT_BOARD_PHOTO_CAPTION =
  'BHG Board Members (L to R): Kinzie Baldwin, Anna Parks, Suzanne Wilkinson, Kathy Wall, Director Beth Perkins';

export function resolveBoardPhotoCaption(caption: string | undefined): string {
  const trimmed = caption?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : DEFAULT_BOARD_PHOTO_CAPTION;
}

/** Public API path for the board photo (302 to S3). Cache-bust with settings updatedAt when set. */
export function boardPhotoPublicUrl(updatedAt?: number): string {
  const base = apiFetchUrl('/public/board-photo');
  if (updatedAt == null || updatedAt <= 0) return base;
  return `${base}?v=${updatedAt}`;
}
